//import yasuo from '../accset/Yasuo_57.jpg'
import avatar from '../accset/avatar_free_8.webp'
import mcoin from '../accset/item_musk.webp'
//import { useWallet, ConnectModal } from "@suiet/wallet-kit";
import { Transaction } from "@mysten/sui/transactions";
import { useEffect, useState } from "react";
import {  useWallet } from "@suiet/wallet-kit";
import "@suiet/wallet-kit/style.css";
import axios from 'axios'
import {WalletProvider, ConnectButton} from "@suiet/wallet-kit";
//import { useParams } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";

// hàm giao dịch sui
async function ReactSendTransaction(amount, wallet, onSuccess, onError ,token ,suiAddr) {

  try {
    console.log(token ,"dd",suiAddr)
    const transaction = new Transaction();
    const [coin] = transaction.splitCoins(transaction.gas, [amount]);
    transaction.transferObjects(
      [coin],
      suiAddr
      // "0x2a46b7d50310f0b0e7cc9eead90d564aac074cd13aafd5fa9a76251dbf9e83be"
    
    );
    const resData = await wallet.signAndExecuteTransaction({ transaction });
    console.log("Transaction successful:", resData);

    if (onSuccess) onSuccess(resData);
    if (resData?.digest){
      await axios.post("https://api-test.m-sci.net/api/sui/submit-transaction", { digest: resData.digest }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("disgit" ,resData.digest );
      console.log("Transaction logged successfully");
    }
    
  } catch (error) {
    console.error("Transaction failed:", error);
    if (onError) onError(error);
  }
}
// modal để comfirm 0,001
function Modal({ isOpen, onClose, coin ,wallet ,token ,suiAddr}) {
  if (!isOpen) return null;
  const handleConfirm = () => {
    ReactSendTransaction(
      100,
      wallet,
      (res) => {
        console.log("Transaction successful", res);
        onClose();
      },
      (err) => console.error("Transaction failed", err),
      token,
      suiAddr
    );
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-gray-800 p-6 rounded-lg text-white w-96 shadow-lg">
        <h2 className="text-xl font-bold mb-4">Confirm Purchase</h2>
        <p>You are about to buy <span className="font-semibold">{coin.price} Sui</span> worth of coins.</p>
        <div className="flex justify-end gap-4 mt-6">
          <button onClick={onClose} className="bg-gray-600 px-4 py-2 rounded">Cancel</button>
          <button  onClick={handleConfirm} className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-400">Confirm</button>
        </div>
      </div>
    </div>
  );
}


function ConnectS(){
  const {connected } = useWallet()
  const wallet = useWallet()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCoin, setSelectedCoin] = useState(null);
  //const { token } = useParams()
  const [userData, setUserData] = useState(null);
  const [suiRate , setSuiRate] =useState(null)
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  //get user
  useEffect(() => {
  
      const fetchUserData = async () => {
        try {
          const response = await axios.get("https://api-test.m-sci.net/api/me", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setUserData(response.data.data);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };

      fetchUserData();
    
  }, [token]);
// get suiRate
  useEffect(() => {
  
    const fetchUserData = async () => {
      try {
        const response = await axios.get("https://api-test.m-sci.net/api/config/rate");
        console.log(response.data);
        setSuiRate(response.data)
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  
}, []);

  // đổi sang dạng M và K
  const formatNumber = (num) => {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M"; 
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1) + "K"; 
    }
    return num.toString(); // Số nhỏ hơn 1K giữ nguyên
  };

      // const coins = new Array(6).fill({
      //   image:mcoin , // Thay bằng URL hình ảnh thực tế
      //   amount: 9999999,
      //   price: 0.001,
      
      // });

      const coins = [
        { image: mcoin, amount: "Basic Pack", price:`${50/suiRate?.suiRate}` },
        { image: mcoin, amount: "Genesis Pack", price:`${200/suiRate?.suiRate}`},
        { image: mcoin, amount: "Glory Pack", price: `${500/suiRate?.suiRate}` },
        { image: mcoin, amount: "Divine Pack", price: `${1000/suiRate?.suiRate}`},
        { image: mcoin, amount: "Immortal Pack", price: `${2000/suiRate?.suiRate}` },
        { image: mcoin, amount: "Emperor Pack", price: `${5000/suiRate?.suiRate}` },
        { image: mcoin, amount: "Golden Pack", price: `${10000/suiRate?.suiRate}` },
        { image: mcoin, amount: "Celestial Pack", price: `${20000/suiRate?.suiRate}`},
        { image: mcoin, amount: "God King Pack", price:`${50000/suiRate?.suiRate}` },
        { image: mcoin, amount: "Legendary Pack", price: `${100000/suiRate?.suiRate}` },
      ];

      const handleBuyClick = (coin) => {
        setSelectedCoin(coin);
        setIsModalOpen(true);
      };
      return (
        <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">

          <div className="flex flex-col items-center gap-4 mb-6">
          {/* <div className="bg-slate-800 text-white p-3 rounded-lg flex items-center w-72">
      <div className="w-12 h-12 rounded-full overflow-hidden mr-3 flex-shrink-0">
        <img 
          src={yasuo} 
          alt="User avatar" 
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="flex-1">
        <h3 className="text-base font-medium mb-1">username</h3>
        <p className="text-xs text-gray-400 mb-2">
          ID: 
        </p>
        
        <div className="text-sm mb-0.5">
          Chip: 
        </div>
        <div className="text-sm mb-0.5">
          Musk: 
        </div>
      </div>
    </div> */}
    
    {userData && (
      <div className='text-white mb-[10%] relative'>
      <div className='w-16 top-[-10%]  h-16 absolute'>
            <img className='object-cover  rounded-full' alt='avatar' src={avatar}/>

            </div>
            <div className='bg-gray-800 flex flex-col  justify-between pl-[80px] pr-[20px] rounded-full'>
              <div className='text-lg font-bold'> {userData?.Username}</div>
              <div  className='text-xs mb-1 text-gray-400'>Id: {userData?.TelegramId}</div>
            </div>
            <div className='pl-[80px] text-gray-200 flex gap-4 pr-[20px] '>
              <div className='text-sm'>
                Chip: {formatNumber(userData.Chip || 0)}
              </div>
              <div className='text-sm'>
              Mcoin: {formatNumber(userData.Musk || 0)}
              </div>
            </div>

    </div>
    )}

        {userData && ( <ConnectButton 
            className="bg-blue-500 text-white font-semibold z-10  rounded-full hover:bg-blue-400"
          >
            Connect wallet
          </ConnectButton>)}

        {/* {connected ? (
          <ConnectButton 
            // onClick={disconnect}
            className="bg-red-500 text-white font-semibold  rounded-full hover:bg-red-400"
          >
            <button>
            Disconnect wallet
            </button>
          </ConnectButton>
        ) : (
          <ConnectButton 
            className="bg-blue-500 text-white font-semibold py-2 px-6 rounded-full hover:bg-blue-400"
          >
            Connect wallet
          </ConnectButton>
        )} */}
        {/* <button className="bg-gray-600 text-gray-300 font-semibold py-2 px-6 rounded-full cursor-not-allowed">
          Change wallet
        </button> */}
      </div>
          <div className="grid grid-cols-2 pt-[1%]  sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl">
            {coins.map((coin, index) => (
              <div key={index} className="bg-black relative rounded-2xl p-4 text-white shadow-lg">
                <img
                  src={coin.image}
                  alt="Coin"
                  className="w-full rounded-xl mb-4 border-2 border-gray-700"
                />
                <p className="text-center bottom-[37%] right-[12%]  absolute text-gray-400 sm:right-[7%] sm:bottom-[25%] text-xs font-bold">{coin.amount}</p>
                
                {connected?(<button onClick={() => handleBuyClick(coin)} className="w-full bg-blue-500 hover:bg-blue-400 text-white font-semibold py-2 px-4 rounded-lg mt-3">
                  Buy {coin.price} Sui
                </button>):(<button className="w-full bg-gray-600 cursor-not-allowed hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-lg mt-3">
                  Buy {coin.price} Sui
                </button>)}

              </div>
            ))}
          </div>
          <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} coin={selectedCoin} wallet={wallet} token={token} suiAddr={suiRate?.suiReceiver}/>
        </div>
      );
    }
export default function ConnectSUI() {
  return (
    <WalletProvider>
      <ConnectS />
    </WalletProvider>
  );
}
